/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars,
  faVolumeXmark,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, dragging, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function DragChangePreview({
  srcs,
  isMediaVisible,
  redirectImage,
  redirectVideo,
}) {
  const containerRef = useRef(null)
  const [canDrag, setCanDrag] = useState(false)
  const [dragX, setDragX] = useState(15)
  const [hasDraggedToRight, setHasDraggedToRight] = useState(false)
  const [isMuted, setIsMuted] = useState(true)
  const [showInitial, setShowInitial] = useState(true)
  const [showExpand, setShowExpand] = useState(true)
  const [showBanner, setShowBanner] = useState(false)

  const beforeImg = srcs.find((s) => s.label === 'Before img')
  const afterImg = srcs.find((s) => s.label === 'After img')
  const dragImg = srcs.find((s) => s.label === 'Drag img')
  const expandImg = srcs.find((s) => s.label === 'Expand Img')
  const expandVideo = srcs.find((s) => s.label === 'Expand Video')

  const isVideoFile = (file) => {
    const type = file?.type || ''
    const name = file?.name || ''
    return type.startsWith('video') || /\.(mp4|mov|webm)$/i.test(name)
  }

  const getPreviewURL = (file) => {
    if (file instanceof File) return URL.createObjectURL(file)
    if (typeof file === 'string' && file.startsWith('blob:')) return file
    return `/api/file/${file}`
  }

  const handleDrag = (e) => {
    if (!containerRef.current || !canDrag) return

    const containerWidth = containerRef.current.offsetWidth
    const dragWidth = 60
    const padding = 15

    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX
    const offsetLeft = containerRef.current.getBoundingClientRect().left
    const relativeX = clientX - offsetLeft

    const clampedX = Math.max(
      padding,
      Math.min(relativeX, containerWidth - dragWidth - padding)
    )

    setDragX(clampedX)

    if (clampedX >= containerWidth - dragWidth - padding - 5) {
      setHasDraggedToRight(true)
    }
  }

  const handleDragStart = () => {
    setCanDrag(true)
  }

  useEffect(() => {
    const handleDragEnd = () => {}

    document.addEventListener('mouseup', handleDragEnd)
    document.addEventListener('touchend', handleDragEnd)

    return () => {
      document.removeEventListener('mouseup', handleDragEnd)
      document.removeEventListener('touchend', handleDragEnd)
    }
  }, [])

  useEffect(() => {
    if (hasDraggedToRight) {
      const timer = setTimeout(() => {
        setShowBanner(true)
      }, 2000)

      return () => clearTimeout(timer)
    }

    return undefined
  }, [hasDraggedToRight])

  const bannerMedia = srcs.find((s) => s.label === 'Banner Video or Img')

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '2%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>

      <div
        style={{
          objectFit: 'cover',
          height: 'auto',
          position: 'absolute',
          bottom: '12%',
          width: '240px',
          zIndex: '1000',
        }}
      >
        <div
          ref={containerRef}
          className="position-relative"
          style={{
            width: '240px',
            minHeight: 'auto',
            margin: '0 auto',
          }}
          onMouseMove={handleDrag}
          onTouchMove={handleDrag}
        >
          {/* Before img or After img */}
          {isMediaVisible && (
            <>
              {showInitial && !hasDraggedToRight && beforeImg?.file && (
                <>
                  <button
                    type="button"
                    onClick={() => setShowInitial(false)}
                    style={{
                      position: 'absolute',
                      bottom: '6rem',
                      right: '6px',
                      zIndex: 1501,
                      backgroundColor: 'rgba(0,0,0,0.5)',
                      border: 'none',
                      borderRadius: '50%',
                      color: 'white',
                      width: '18px',
                      height: '18px',
                      fontSize: '12px',
                      cursor: 'pointer',
                    }}
                  >
                    ✕
                  </button>
                  <>
                    <img
                      className="d-flex"
                      src={getPreviewURL(beforeImg.file)}
                      alt="Before"
                      style={{
                        objectFit: 'cover',
                        height: 'auto',
                        position: 'absolute',
                        bottom: '12%',
                        width: '240px',
                        zIndex: '1000',
                        transition: '1s',
                      }}
                    />
                    <CIIcon />
                  </>
                </>
              )}

              {showInitial &&
                hasDraggedToRight &&
                !showBanner &&
                afterImg?.file && (
                  <>
                    <img
                      className="d-flex"
                      src={getPreviewURL(afterImg.file)}
                      alt="After"
                      style={{
                        objectFit: 'cover',
                        height: 'auto',
                        position: 'absolute',
                        bottom: '12%',
                        width: '240px',
                        zIndex: '1000',
                        transition: '1s',
                      }}
                    />
                    <CIIcon />
                  </>
                )}

              {/* Banner (Video or Img) */}
              {hasDraggedToRight &&
                showBanner &&
                showExpand &&
                bannerMedia?.file &&
                (isVideoFile(bannerMedia.file) ? (
                  <div
                    role="presentation"
                    onClick={(e) => {
                      if (e.target.closest('a')) return
                      if (redirectVideo) window.open(redirectVideo, '_blank')
                    }}
                    style={{ width: '100%', height: '100%', cursor: 'pointer' }}
                  >
                    <video
                      key={getPreviewURL(bannerMedia.file)}
                      src={getPreviewURL(bannerMedia.file)}
                      autoPlay
                      muted={isMuted}
                      loop
                      playsInline
                      style={{
                        width: '240px',
                        height: '120px',
                        position: 'absolute',
                        bottom: '12%',
                        zIndex: '1000',
                        backgroundColor: 'black',
                      }}
                    >
                      <track kind="captions" srcLang="en" src="" default />
                    </video>
                    <CIIcon />
                  </div>
                ) : (
                  <div
                    role="presentation"
                    onClick={(e) => {
                      if (e.target.closest('a')) return
                      if (redirectVideo) window.open(redirectVideo, '_blank')
                    }}
                    style={{ width: '100%', height: '100%', cursor: 'pointer' }}
                  >
                    <img
                      src={getPreviewURL(bannerMedia.file)}
                      alt="Banner"
                      style={{
                        width: '240px',
                        position: 'absolute',
                        bottom: '12%',
                        zIndex: '1000',
                      }}
                    />
                    <CIIcon />
                  </div>
                ))}

              {/* Dragged img */}
              {showInitial && !hasDraggedToRight && dragImg?.file && (
                <>
                  <img
                    role="presentation"
                    src={getPreviewURL(dragImg.file)}
                    alt="Drag"
                    onClick={() => setCanDrag(true)}
                    onMouseDown={handleDragStart}
                    onTouchStart={handleDragStart}
                    style={{
                      position: 'absolute',
                      bottom: '12%',
                      left: `${dragX}px`,
                      width: '80px',
                      height: 'auto',
                      zIndex: '1100',
                      transform: 'translateY(0%)',
                      pointerEvents: 'auto',
                      cursor: 'grab',
                      animation: 'dragHintLeftRight 1.8s ease-in-out infinite',
                    }}
                  />

                  <img
                    src={dragging}
                    alt="Drag Hint"
                    style={{
                      position: 'absolute',
                      bottom: '11.5%',
                      left: '15px',
                      width: '40px',
                      height: 'auto',
                      zIndex: 1150,
                      animation: 'dragMove 1.8s ease-in-out infinite',
                      pointerEvents: 'none',
                      opacity: 0.75,
                    }}
                  />
                </>
              )}
            </>
          )}

          {/* Expand Img */}
          {showBanner && showExpand && (
            <>
              {expandImg?.file && (
                <>
                  <img
                    src={getPreviewURL(expandImg.file)}
                    alt="Expand"
                    style={{
                      position: 'absolute',
                      bottom: '8rem',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      zIndex: 1010,
                      width: '200px',
                      height: 'auto',
                    }}
                    onClick={() => {
                      if (redirectImage) window.open(redirectImage, '_blank')
                    }}
                    role="presentation"
                  />
                  <button
                    type="button"
                    onClick={() => setShowExpand(false)}
                    style={{
                      position: 'absolute',
                      bottom: '27rem',
                      right: '0.5rem',
                      zIndex: 1501,
                      backgroundColor: 'rgba(0,0,0,0.5)',
                      border: 'none',
                      borderRadius: '50%',
                      color: 'white',
                      width: '18px',
                      height: '18px',
                      fontSize: '12px',
                      cursor: 'pointer',
                    }}
                  >
                    ✕
                  </button>
                </>
              )}

              {/* Expand Video */}
              {expandVideo?.file && (
                <>
                  <video
                    src={getPreviewURL(expandVideo.file)}
                    autoPlay
                    muted={isMuted}
                    loop
                    playsInline
                    style={{
                      position: 'absolute',
                      bottom: '19.75rem',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      zIndex: 1020,
                      width: '200px',
                      height: 'auto',
                    }}
                    onClick={() => {
                      if (redirectImage) window.open(redirectImage, '_blank')
                    }}
                  >
                    <track kind="captions" srcLang="en" src="" default />
                  </video>
                  <CIIcon />
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation()
                      setIsMuted((prev) => !prev)
                    }}
                    style={{
                      position: 'absolute',
                      left: '30px',
                      bottom: '400px',
                      zIndex: 1501,
                      backgroundColor: 'rgba(0,0,0,0.5)',
                      borderRadius: '50%',
                      width: '20px',
                      height: '20px',
                      border: 'none',
                      color: 'white',
                      fontSize: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <FontAwesomeIcon
                      icon={isMuted ? faVolumeXmark : faVolumeHigh}
                    />
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>

      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

DragChangePreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  redirectImage: PropTypes.string,
  redirectVideo: PropTypes.string,
  isMediaVisible: PropTypes.bool.isRequired,
}

DragChangePreview.defaultProps = {
  srcs: [],
  redirectImage: '',
  redirectVideo: '',
}

export default DragChangePreview
